"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Image;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Image(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "image"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M79.79,30.23,69.1,19.54,58.86,8.84a4.52,4.52,0,0,0-3.25-1.39H23.39a4.51,4.51,0,0,0-4.5,4.5V88a4.5,4.5,0,0,0,4.5,4.49H76.61A4.5,4.5,0,0,0,81.11,88V33.41A4.47,4.47,0,0,0,79.79,30.23ZM65.52,23l7.88,7.87H58.71a2.58,2.58,0,0,1-.6-.59v-15ZM23.89,87.45v-75H53.11V30.59c0,2.48,2.85,5.32,5.35,5.32H76.11V87.45ZM71.27,58.88A2.51,2.51,0,0,1,72,60.65v22a2.5,2.5,0,0,1-2.5,2.5h-39a2.5,2.5,0,0,1-2.5-2.5V72a2.47,2.47,0,0,1,.79-1.82l9.05-8.51a2.49,2.49,0,0,1,3.48,0L47.63,68l14.61-14.6a2.56,2.56,0,0,1,3.53,0Zm-39-14.23a8,8,0,1,1,8,8A8,8,0,0,1,32.22,44.65Z"
  }))));
}